import React from 'react';

interface BadgeProps {
  variant?: 'active' | 'inactive' | 'admin' | 'user' | 'warning' | 'info';
  children: React.ReactNode;
}

export const Badge: React.FC<BadgeProps> = ({ variant = 'info', children }) => {
  const variantMap = {
    active: {
      backgroundColor: '#28a745',
      color: 'var(--color-white)',
    },
    inactive: {
      backgroundColor: 'var(--color-light-grey)',
      color: 'var(--color-dark-grey)',
    },
    admin: {
      backgroundColor: 'var(--color-magenta)',
      color: 'var(--color-white)',
    },
    user: {
      backgroundColor: 'var(--color-dark-grey)',
      color: 'var(--color-white)',
    },
    warning: {
      backgroundColor: '#ffc107',
      color: '#000000',
    },
    info: {
      backgroundColor: '#17a2b8',
      color: 'var(--color-white)',
    },
  };

  const style: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '2px 8px',
    fontSize: '12px',
    fontFamily: 'var(--font-family)',
    fontWeight: 500,
    borderRadius: '12px',
    whiteSpace: 'nowrap',
    ...variantMap[variant],
  };

  return <span style={style}>{children}</span>;
};
